import type { AuctionItem } from "@/contexts/GameContext";

export const mockAuctions: AuctionItem[] = [
  {
    id: "auction-001",
    blockId: "51.5074_-0.1278_16",
    blockLat: 51.5074,
    blockLng: -0.1278,
    sellerId: "user-003",
    sellerName: "James_Smith",
    startPrice: 100,
    currentBid: 480,
    currentBidder: "user-011",
    endTime: "2026-04-03T12:00:00Z",
    duration: "24h",
  },
  {
    id: "auction-002",
    blockId: "55.7558_37.6173_16",
    blockLat: 55.7558,
    blockLng: 37.6173,
    sellerId: "user-006",
    sellerName: "Ivan_Petrov",
    startPrice: 100,
    currentBid: 220,
    currentBidder: "user-012",
    endTime: "2026-04-03T04:00:00Z",
    duration: "8h",
  },
  {
    id: "auction-003",
    blockId: "35.6895_139.6917_16",
    blockLat: 35.6895,
    blockLng: 139.6917,
    sellerId: "user-013",
    sellerName: "Yuki_Suzuki",
    startPrice: 100,
    currentBid: 1250,
    currentBidder: "user-014",
    endTime: "2026-04-05T18:00:00Z",
    duration: "3d",
  },
  {
    id: "auction-004",
    blockId: "-22.9068_-43.1729_16",
    blockLat: -22.9068,
    blockLng: -43.1729,
    sellerId: "user-015",
    sellerName: "Maria_Oliveira",
    startPrice: 100,
    currentBid: 350,
    currentBidder: null,
    endTime: "2026-04-04T20:00:00Z",
    duration: "24h",
  },
  {
    id: "auction-005",
    blockId: "48.2082_16.3738_16",
    blockLat: 48.2082,
    blockLng: 16.3738,
    sellerId: "user-016",
    sellerName: "Hans_Mueller",
    startPrice: 100,
    currentBid: 700,
    currentBidder: "user-017",
    endTime: "2026-04-06T10:00:00Z",
    duration: "3d",
  },
];
